import React, { useEffect } from 'react'

import { alertsSection, isNoAvailabilityTabLoading } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import NoAvailabilityDrawer from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer"
import NoAvailabilityTable from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Table"
import { BACKEND_APIS } from "@constants"
import { isTourDemoActive } from "@signals/app"


export default function NoAvailabilityBlock() {

	const {
		isAlertSubmitting,
		onEditAlert,
		onSubmitAlert,
		getTableData,
		tableData,
		isTableLoading,
		onDeleteAlert,
	} = useAlertsTableData(`${BACKEND_APIS.CONDITIONS}/not-available`)

	useEffect(() => {
		isNoAvailabilityTabLoading.value = true
		getTableData()
			.then(() => isNoAvailabilityTabLoading.value = false)
			.catch(() => isNoAvailabilityTabLoading.value = false)
	}, [])


	if (alertsSection.value !== ALERTS.NO_AVAILABILITY) return <></>

	return <>
		{!(isTourDemoActive.value && !tableData?.length) && <NoAvailabilityTable
			data={tableData}
			onDeleteAlert={onDeleteAlert}
			onEditAlert={onEditAlert}
			isLoading={isTableLoading}
		/>}
		<NoAvailabilityDrawer onSubmitAlert={onSubmitAlert} isLoading={isAlertSubmitting}/>
	</>
}